export default __webpack_public_path__ + "static/media/unavailable_m.aac8e7bb.png";